// NEED TO ADD COMETCHAT KEYS ONCE CLONED
export const CometChat = () => {
	const regID = window.dataLayer[0]["Registrant ID"]
	const userName = (() => {
		const pronoums = window.dataLayer[0]["Include Pronouns (optional):"]
		let name = window.dataLayer[0]["Preferred Name:"]
		if (pronoums && pronoums != "")
			return `${name} (${pronoums})`

		return name
	})()

	const picture = "https://assets.swoogo.com/uploads/medium/1593467-620aa8dc77129.png"
	const regUid = regID.toString()

	const loadStage4 = () => {
		window.CometChatWidget.launch({
			alignment: "right",
			docked: "true",
			roundedCorners: "true",
			height: "50vh",
			width: "26vw",
			widgetID: "89214f2e-67a0-441c-8a91-27ce06aa8631",
		})
	}

	const loadStage3 = () => {
		// You can now call login function.
		window.CometChatWidget.login({
			uid: regUid,
		}).then(loadStage4)
	}

	const loadStage2 = () => {
		window.CometChatWidget.createOrUpdateUser({
			avatar: picture,
			name: userName,
			uid: regUid,
		}).then(loadStage3)
	}

	const loadStage1 = () => {
		window.CometChatWidget.init({
			appID: "20456696684b0b6d",
			appRegion: "us",
			authKey: "66bd16e903dc242e5154bfc49ab00a7b1c6ffba4",
		}).then(loadStage2)
	}

	const bootChatIfReady = () => {
		if (window.CometChatWidget === undefined) {
			setTimeout(bootChatIfReady, 250)
		} else { loadStage1() }
	}

	bootChatIfReady()

	return <script defer src="https://widget-js.cometchat.io/v3/cometchatwidget.js" />
}
